import Vue from 'vue'
import Router from 'vue-router'
import HomePage from './views/HomePage.vue'
import PrivacyPolicyPage from './views/PrivacyPolicyPage.vue'
import ValeCampaignPage from './views/ValeCampaignPage.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomePage
    },
    {
      path: '/politica-privacidade',
      name: 'politica-privacidade',
      component: PrivacyPolicyPage
    },
    {
      path: '/9eac-vale',
      name: 'campanha-vale',
      component: ValeCampaignPage
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})
